import React from "react";

import Modal, { ModalCloseButton } from "@app/analytics/components/Modal";
import useMeetingReportUiStore from "@app/analytics/MeetingReport/stores/ui";
import { MeetingReportDialog } from "@app/analytics/MeetingReport/types";

import { ModalTitle } from "@rui/Modal";
import { Column, Row } from "@rui/Stack";

const MobileDialog = ({
  id,
  title,
  children,
  headerAction,
}: {
  id: MeetingReportDialog;
  title: string;
  children: React.ReactNode;
  headerAction?: React.ReactNode;
}) => {
  const [dialog, setDialog] = useMeetingReportUiStore((state) => [
    state.dialog,
    state.setDialog,
  ]);

  const closeDialog = () => setDialog(null);

  return (
    <Modal
      open={dialog === id}
      disableAutoFocus
      onClose={closeDialog}
      sx={{ width: "360px" }}
    >
      <Column py={2} px={3} spacing={2}>
        <Row variant="apart" spacing={1}>
          <ModalTitle>{title}</ModalTitle>
          {headerAction ?? <ModalCloseButton onClick={closeDialog} />}
        </Row>
        {children}
      </Column>
    </Modal>
  );
};

export default MobileDialog;
